import React, { useMemo, useState } from "react";
import { useRef } from "react";
// import { useState } from 'react';
import { useEffect } from "react";
import { useDropzone } from "react-dropzone";
// import { cuteToast } from "../../UI/cute";
import TagsInput from "../../UI/TagsInput";
import Input from "../../UI/Input";
import useHttp from "../../../hooks/use-http";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";

import { personalizeAction } from "../../../store/pesonalize-store";
import { authActions } from "../../../store/auth"
import { useHistory } from "react-router-dom";
import UploadService from "../../../Services/FileUploadServices";
// import Loader from "../../UI/loader";
import { cuteToast } from "../../UI/cute";

const ImportvideoModals = ({ setShowCreate, setShowImportvideo }) => {
  const [uploadFiles, setUploadFiles] = useState([]);
  const [showDropzone, setShowDropzone] = useState(true);
  const [showUploadFiles, setShowUploadFiles] = useState(false);
  const [showFiles, setShowFiles] = useState(false);
  const [addTags, setAddTags] = useState([]);
  const [addDesc, setAddDesc] = useState("");
  const campaignRef = useRef();
  const [campaign, setCampaign] = useState({
    campaign_name: "",
    is_available: undefined,
  });
  const [isValid, setIsValid] = useState(undefined);

  const [progress, setProgress] = useState(0);
  const [progressSection, setProgressSection] = useState(false);
  const token = useSelector((state) => state.auth.token);

  const [showYtSection, setShowYtSection] = useState(true);
  const [showYtVideoFiles, setShowYtVideoFiles] = useState(false);
  const [ytvideoLink, setytvideoLink] = useState("");

  const [showVimeoSection, setShowVimeoSection] = useState(true);
  const [showVmVideoFiles, setShowVmVideoFiles] = useState(false);
  const [vmvideoLink, setvmvideoLink] = useState("");

  const { sendRequest: checkCampaign } = useHttp();
  // const { sendRequest: uploadVideo } = useHttp();
  const history = useHistory();
  const { error, setError, sendRequest: insertCampaign } = useHttp();

  const dispatch = useDispatch();

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
  };

  const focusedStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#000000",
  };

  function filesizeValidator(file) {
    if (file.size > 15728640) {
      return {
        code: "file-too-large",
        message: `File Size should not be more than ${formatBytes(15728640)}`,
      };
    }

    return null;
  }

  const {
    getRootProps: getRootFirstProps,
    getInputProps: getInputFirstProps,
    isFocused,
    isDragAccept,
    isDragReject,
    fileRejections,
    acceptedFiles,
  } = useDropzone({
    accept: "video/quicktime,video/mp4,video/x-flv,video/*",
    maxFiles: 1,
    validator: filesizeValidator,
  });

  const {
    getRootProps: getRootSecondaryProps,
    getInputProps: getInputSecondaryProps,
    fileRejections: fileRejectionsSecondaryUpload,
    acceptedFiles: acceptedFilesSecondaryUpload,
  } = useDropzone({
    accept: "video/quicktime,video/mp4,video/x-flv,video/*",
    maxFiles: 1,
    validator: filesizeValidator,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <div key={file.path}>
      {file.path} - {file.size} bytes
      <div className="d-inline-flex text-danger ms-sm-3">
        {errors.map((e) => (
          <span key={e.code}>{e.message}</span>
        ))}
      </div>
    </div>
  ));

  const fileRejectionSecondaryItems = fileRejectionsSecondaryUpload.map(
    ({ file, errors }) => (
      <div key={file.path}>
        {file.path} - {file.size} bytes
        <div className="d-inline-flex text-danger ms-sm-3">
          {errors.map((e) => (
            <span key={e.code}>{e.message}</span>
          ))}
        </div>
      </div>
    )
  );

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const responseData = (response) => {
    // console.log(campaign);

    if (response.status === 0) {
      setCampaign((prev) => {
        return {
          ...prev,
          is_available: true,
        };
      });
    } else {
      setCampaign((prev) => {
        return {
          ...prev,
          is_available: false,
        };
      });
    }
  };

  const campaignHandler = (event) => {
    const { value } = event.target;
    // console.log(value);
    // if (value ) {
    setCampaign({ ...campaign, campaign_name: value });
    // } else {
    //   setIsValid(false);
    // }
    // console.log(campaign);
  };

  const campaignHandlerBlur = () => {
    if (campaign.campaign_name && campaign.campaign_name.length > 0) {
      checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          body: {
            name: campaign.campaign_name,
          },
        },
        responseData
      );
    } else if (campaign.campaign_name.length === 0) {
      setCampaign((prev) => {
        return {
          ...prev,
          is_available: false,
        };
      });
    }
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isFocused, isDragAccept, isDragReject]
  );

  useEffect(() => {
    setShowCreate(false);
  });

  useEffect(() => {
    // console.log('here');
    async function checkCampaignData(type) {
      let campaign_name;
      if (type === "first") {
        setShowDropzone(false);
        setShowUploadFiles(true);
        campaign_name = acceptedFiles[0].name.slice(
          0,
          acceptedFiles[0].name.lastIndexOf(".")
        );
        // console.log(campaign_name)
        setUploadFiles(acceptedFiles);
        setCampaign((prevValue) => {
          return {
            ...prevValue,
            campaign_name,
          };
        });
        setIsValid(true);
      }

      if (type === "secondary") {
        setShowDropzone(false);
        setShowUploadFiles(true);
        setShowFiles(false);

        campaign_name = acceptedFilesSecondaryUpload[0].name.slice(
          0,
          acceptedFilesSecondaryUpload[0].name.lastIndexOf(".")
        );
        // console.log(campaign_name)
        setUploadFiles(acceptedFilesSecondaryUpload);
        setCampaign((prevValue) => {
          return {
            ...prevValue,
            campaign_name: acceptedFilesSecondaryUpload[0].name.slice(
              0,
              acceptedFilesSecondaryUpload[0].name.lastIndexOf(".")
            ),
          };
        });
        setIsValid(true);
      }

      await checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          body: {
            name: campaign_name,
          },
        },
        responseData
      );
      // console.log(campaign_name)
    }

    if (acceptedFiles && acceptedFiles.length > 0) {
      checkCampaignData("first");
    }

    if (
      acceptedFilesSecondaryUpload &&
      acceptedFilesSecondaryUpload.length > 0
    ) {
      checkCampaignData("secondary");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [acceptedFiles, acceptedFilesSecondaryUpload]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (error) {
      //   console.log(error);

      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });

      setCampaign({ ...campaign, is_available: false });
      //   campaignRef.current.focus();
      setError(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const youtubeRef = useRef();
  const vimeoRef = useRef();

  const resposeCamp = (response) => {
    // console.log(response);

    dispatch(
      personalizeAction.setPersonalizepageLoad({ personalize_page_load: false })
    );

    if (response.id) {
      history.push("/video/view/" + response.id);
    }
  };

  const handleClick = async (event, type) => {
    event.preventDefault();
    let videoId;
    if (type === "youtube") {
      youtubeRef.current.value.length <= 0 && youtubeRef.current.focus();
      if (
        youtubeRef.current.value.includes("https://www.youtube.com/watch?v=")
      ) {
        videoId = youtubeRef.current.value.replace(
          "https://www.youtube.com/watch?v=",
          ""
        );

        setytvideoLink("https://www.youtube.com/embed/" + videoId);

        setShowYtVideoFiles(true);
        setShowYtSection(false);
        setIsValid(true);
        // console.log(video_link)
      }
    }

    if (type === "vimeo") {
      vimeoRef.current.value.length <= 0 && vimeoRef.current.focus();
      if (vimeoRef.current.value.includes("https://vimeo.com/")) {
        videoId = youtubeRef.current.value.replace("https://vimeo.com/", "");
        setvmvideoLink("https://player.vimeo.com/video/" + videoId);
        setShowVmVideoFiles(true);
        setShowVimeoSection(false);
        setIsValid(true);
      }
    }

    if (type === "import") {
      if (isValid && campaign.is_available) {
        setShowUploadFiles(false);
        setShowFiles(false);
        setShowDropzone(false);
        setProgressSection(true);
        dispatch(authActions.setLoaderStatus({ status: true,loader_text:"Uploading file..."}));
        UploadService.uploadVideo(uploadFiles[0], token, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
          .then((response) => {
            if (response.status === 200) {
                dispatch(authActions.setLoaderStatus({ status: true,loader_text:"Creating Your Campaign"}));
                insertCampaign(
                {
                  url: endPoints.createCampaign,
                  method: "POST",
                  body: {
                    ...campaign,
                    addTags,
                    addDesc,
                    filename: response.data.url,
                    video_type: "cust_upload",
                  },
                },
                resposeCamp
              );
            }
          })
          .catch(() => {
            setProgress(0);
            // setMessage("Could not upload the file!");
            setUploadFiles(undefined);
            setShowUploadFiles(true);
            setShowFiles(false);
            setShowDropzone(false);
            setProgressSection(false);
            dispatch(authActions.setLoaderStatus({ status: false,loader_text:""}));
          });
      } else {
        cuteToast({
          type: "error",
          message: "Please check campaign name and upload video",
          timer: 5000,
          title: "",
        });
      }
    }

    if (type === "getYTvideo") {
      if (campaign.campaign_name.length > 0 && isValid) {
        insertCampaign(
          {
            url: endPoints.createCampaign,
            method: "POST",
            body: {
              ...campaign,
              addTags,
              addDesc,
              filename: ytvideoLink,
              video_type: "embed",
            },
          },
          resposeCamp
        );
      } else {
        cuteToast({
          type: "error",
          message: "Please check campaign name and Embed video",
          timer: 5000,
          title: "",
        });
      }
    }

    if (type === "getVimeovideo") {
      if (campaign.campaign_name.length > 0 && isValid) {
        insertCampaign(
          {
            url: endPoints.createCampaign,
            method: "POST",
            body: {
              ...campaign,
              addTags,
              addDesc,
              filename: vmvideoLink,
              video_type: "embed",
            },
          },
          resposeCamp
        );
      } else {
        cuteToast({
          type: "error",
          message: "Please check campaign name and Embed video",
          timer: 5000,
          title: "",
        });
      }
    }
  };

  const handleChange = (event, type) => {
    event.preventDefault();

    if (type === "showFiles") {
      setShowFiles(true);
      setShowDropzone(false);
      setShowUploadFiles(false);
    }

    if (type === "showUploadFiles") {
      setShowUploadFiles(true);
      setShowFiles(false);
      setShowDropzone(false);
    }

    if (type === "changeYtVideo") {
      setShowYtVideoFiles(false);
      setShowYtSection(true);
      setytvideoLink("");
    }

    if (type === "changeVmVideo") {
      setShowVmVideoFiles(false);
      setShowVimeoSection(true);
      setvmvideoLink("");
    }
  };

  return (
    <>
      <div
        className="modal popup1 fade show d-block"
        id="modalImportvideo"
        tabIndex="-1"
        aria-labelledby="modalImportvideoLabel"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalImportvideoLabel">
                Import Video
              </h5>
              <button
                type="button"
                className="close_btn1"
                aria-label="Close"
                onClick={() => setShowImportvideo(false)}
              >
                <i className="fa fa-close"></i>
              </button>
            </div>
            <div className="modal-body navpill_section p-4">
              <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-local-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-local"
                    type="button"
                    role="tab"
                    aria-controls="nav-local"
                    aria-selected="true"
                  >
                    Local
                  </button>
                  {/* <button className="nav-link" id="nav-recordedvideo-tab" data-bs-toggle="tab" data-bs-target="#nav-recordedvideo" type="button" role="tab" aria-controls="nav-recordedvideo" aria-selected="false">RECORDED VIDEO</button> */}
                  {/* <button className="nav-link" id="nav-gdrive-tab" data-bs-toggle="tab" data-bs-target="#nav-gdrive" type="button" role="tab" aria-controls="nav-gdrive" aria-selected="false">g drive</button>  */}
                  <button
                    className="nav-link"
                    id="nav-youtube-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-youtube"
                    type="button"
                    role="tab"
                    aria-controls="nav-youtube"
                    aria-selected="false"
                  >
                    YOUTUBE
                  </button>
                  {/* <button className="nav-link" id="nav-vimeo-tab" data-bs-toggle="tab" data-bs-target="#nav-vimeo" type="button" role="tab" aria-controls="nav-vimeo" aria-selected="false">Vimeo</button> */}
                </div>
              </nav>
              <div className="tab-content p-4 pb-0" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="nav-local"
                  role="tabpanel"
                  aria-labelledby="nav-local-tab"
                >
                  <div className="v_c_import mb-4">
                    {showDropzone && (
                      <>
                        <div
                          className="image-upload"
                          {...getRootFirstProps({ style })}
                        >
                          <label
                            style={{ cursor: "pointer" }}
                            htmlFor="file_upload"
                          >
                            <div className="h-100">
                              <div className="dplay-tbl">
                                <div className="dplay-tbl-cell">
                                  <i>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/upload.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </i>
                                  <input {...getInputFirstProps()} />
                                  <h6 className="pt-2 m-0">
                                    Drag & Drop your file here
                                  </h6>
                                </div>
                              </div>
                            </div>
                            {/* <!--upload-content-->  */}
                            {/* <input type="file" name="image_name" id="file_upload" className="image-input" data-traget-resolution="image_resolution" accept="video/quicktime,video/mp4,video/x-flv,video/*"/> */}
                          </label>
                        </div>
                        <div className="my-2">{fileRejectionItems}</div>
                      </>
                    )}

                    {showUploadFiles &&
                      uploadFiles.map((file) => (
                        <div
                          className="acceptFiles"
                          key={file.name.slice(0, file.name.lastIndexOf("."))}
                        >
                          <div className="form-group row">
                            <label
                              htmlFor="inputCname"
                              className="col-sm-2 col-form-label"
                            >
                              Campaign Name
                            </label>
                            <div className="col-sm-10">
                              <Input
                                ref={campaignRef}
                                name="campaign_name"
                                type="text"
                                placeholder="Enter Campaign Name"
                                maxLength={31}
                                inputClass={`form-control ${
                                  campaign.campaign_name.length >= 31 &&
                                  "is-invalid max-length"
                                } ${
                                  !campaign.is_available &&
                                  campaign.is_available !== undefined &&
                                  "is-invalid invalid"
                                } ${campaign.is_available && "is-valid"}`}
                                onChange={campaignHandler}
                                onBlur={campaignHandlerBlur}
                                value={campaign.campaign_name}
                              />

                              {!campaign.is_available &&
                                campaign.is_available !== undefined && (
                                  <div className={`invalid-feedback`}>
                                    Already Exist!
                                  </div>
                                )}
                              {campaign.campaign_name.length >= 31 && (
                                <div className={`invalid-feedback`}>
                                  Campaign Name should not be Exceeded 30 Char
                                </div>
                              )}
                              {campaign.is_available &&
                                campaign.campaign_name.length <= 30 && (
                                  <div className={`valid-feedback`}>
                                    {"Available"}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="staticEmail"
                              className="col-sm-2 col-form-label"
                            >
                              Selected File
                            </label>
                            <div className="col-sm-10">
                              <div className="small-8 pull-left image-gallery">
                                <div className="image pull-left import-video-form-preview">
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/video-thumb.jpg"
                                    }
                                    alt="Video Thumbnail"
                                    className="gallery-view"
                                  />
                                </div>
                                <div className="pull-left desc-container p-4">
                                  <label className="import-file-name">
                                    {" "}
                                    {file.path}{" "}
                                  </label>
                                  <label className="import-file-size">
                                    {" "}
                                    {formatBytes(file.size)}{" "}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className="form-group row">
                                                    <label htmlFor="inputVtitle" className="col-sm-2 col-form-label">Video Title </label>
                                                    <div className="col-sm-10">
                                                        <input type="text" className="form-control" id="inputVtitle" placeholder="Video Title" value={file.name.slice(0, file.name.lastIndexOf("."))}/>
                                                    </div>
                                                </div> */}

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Add Tags{" "}
                            </label>
                            <div className="col-sm-10">
                              <TagsInput
                                selectedTags={addTags}
                                setAddTags={setAddTags}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Description{" "}
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control height80"
                                placeholder="Enter a nice description..."
                                onChange={(event) =>
                                  setAddDesc(event.target.value)
                                }
                                value={addDesc}
                              />
                            </div>
                          </div>
                        </div>
                      ))}

                    {progressSection && (
                      <>
                        <div className="progress">
                          <div
                            className="progress-bar progress-bar-info progress-bar-striped"
                            role="progressbar"
                            aria-valuenow={progress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: progress + "%" }}
                          >
                            {progress}%
                          </div>
                        </div>
                      </>
                    )}

                    {showFiles && (
                      <>
                        <div className="row">
                          {/* <div className="col-md-2 col-6"> */}
                          <div className="rv_col mb-4 localfile text-center">
                            <button
                              className="d-block border-0 bg-transparent mx-auto"
                              onClick={(e) =>
                                handleChange(e, "showUploadFiles")
                              }
                            >
                              <figure className="mt-2 mb-0">
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "/assets/images/video-thumb.jpg"
                                  }
                                  className=""
                                  alt="img"
                                  data-name={acceptedFiles[0].name}
                                  data-category="localfile"
                                />
                              </figure>
                              <figcaption className="p-2">
                                <h6>{acceptedFiles[0].name}</h6>
                              </figcaption>
                            </button>
                          </div>
                          <div
                            className="rv_col mb-4 localfile text-center secondary-upload"
                            {...getRootSecondaryProps({})}
                          >
                            <button
                              className="d-block border-0 bg-transparent mx-auto"
                              // onClick={(e)=>handleChange(e,'secondaryUpload')}
                            >
                              <figure className="mb-0">
                                {/* <input 
                                                                    type="file" 
                                                                    name="additional_files" 
                                                                    className="d-none" 
                                                                    accept="video/quicktime, video/mp4, video/x-flv, video/*"
                                                                /> */}
                                <input {...getInputSecondaryProps()} />
                                <i className="fas fa-plus"></i>
                              </figure>
                            </button>
                          </div>
                          {/* </div> */}
                        </div>
                        <div className="my-2">
                          {fileRejectionSecondaryItems}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="iv_footer">
                    <div className="note_rw text-left pt-2 pb-3">
                      <span className="text-danger">NOTE :</span> You can select
                      only 1 file. Supports MP4, MKV, MPEG, 3GP formats with max
                      file size of 15MB.
                    </div>
                    <div className="btn_wrap_p text-end">
                      {showUploadFiles && (
                        <button
                          className="btn btn2 me-2"
                          onClick={(e) => handleChange(e, "showFiles")}
                        >
                          Change File
                        </button>
                      )}

                      {showDropzone && (
                        <button
                          className="btn btn2 me-2"
                          onClick={() => setShowImportvideo(false)}
                        >
                          Cancel
                        </button>
                      )}
                      <button
                        className="btn btn1"
                        disabled={
                          uploadFiles && uploadFiles.length > 0 ? false : true
                        }
                        onClick={(e) => handleClick(e, "import")}
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="nav-youtube"
                  role="tabpanel"
                  aria-labelledby="nav-youtube-tab"
                >
                  <div className="youtube_sec">
                    <div className="pt-3 pb-5">
                      {showYtSection && (
                        <form className="form_iv2 text-center m-auto">
                          <div className="social_logo mb-4 pb-2">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/youtube_logo.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                          <input
                            type="text"
                            className="form-control txt_f_1 mb-3"
                            placeholder="Enter Video Link Here"
                            ref={youtubeRef}
                          />
                          <button
                            className="btn w-100 youtube_btn"
                            onClick={(event) => handleClick(event, "youtube")}
                          >
                            Get Video
                          </button>
                        </form>
                      )}

                      {showYtVideoFiles && (
                        <div className="acceptFiles">
                          <div className="form-group row">
                            <label
                              htmlFor="inputCname"
                              className="col-sm-2 col-form-label"
                            >
                              Campaign Name
                            </label>
                            <div className="col-sm-10">
                              <Input
                                ref={campaignRef}
                                name="campaign_name"
                                type="text"
                                placeholder="Enter Campaign Name"
                                maxLength={31}
                                inputClass={`form-control ${
                                  campaign.campaign_name.length >= 31 &&
                                  "is-invalid max-length"
                                } ${
                                  !campaign.is_available &&
                                  campaign.is_available !== undefined &&
                                  "is-invalid invalid"
                                } ${campaign.is_available && "is-valid"}`}
                                onChange={campaignHandler}
                                onBlur={campaignHandlerBlur}
                                value={campaign.campaign_name}
                                autoFocus={true}
                              />

                              {!campaign.is_available &&
                                campaign.is_available !== undefined && (
                                  <div className={`invalid-feedback`}>
                                    Already Exist!
                                  </div>
                                )}
                              {campaign.campaign_name.length >= 31 && (
                                <div className={`invalid-feedback`}>
                                  Campaign Name should not be Exceeded 30 Char
                                </div>
                              )}
                              {campaign.is_available &&
                                campaign.campaign_name.length <= 30 && (
                                  <div className={`valid-feedback`}>
                                    {"Available"}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="staticEmail"
                              className="col-sm-2 col-form-label"
                            >
                              Selected File
                            </label>
                            <div className="col-sm-10">
                              <div className="small-8 pull-left image-gallery">
                                <div className="image pull-left import-video-form-preview">
                                  {/* <img src={process.env.PUBLIC_URL+"/assets/images/video-thumb.png"} alt="Video Thumbnail" className="gallery-view"/> */}
                                  <iframe
                                    src={ytvideoLink}
                                    title="Your Video"
                                  ></iframe>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Add Tags{" "}
                            </label>
                            <div className="col-sm-10">
                              <TagsInput
                                selectedTags={addTags}
                                setAddTags={setAddTags}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Description{" "}
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control height80"
                                placeholder="Enter a nice description..."
                                onChange={(event) =>
                                  setAddDesc(event.target.value)
                                }
                                value={addDesc}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="iv_footer">
                      <div className="btn_wrap_p text-end mt-4">
                        {showYtVideoFiles && (
                          <button
                            className="btn btn2 me-2"
                            onClick={(e) => handleChange(e, "changeYtVideo")}
                          >
                            Change Video
                          </button>
                        )}

                        {showYtSection && (
                          <button
                            className="btn btn2 me-2"
                            onClick={() => setShowImportvideo(false)}
                          >
                            Cancel
                          </button>
                        )}
                        <button
                          className="btn btn1"
                          disabled={
                            ytvideoLink.length === 0 ||
                            campaign.campaign_name.length === 0
                              ? true
                              : false
                          }
                          onClick={(e) => handleClick(e, "getYTvideo")}
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="nav-vimeo"
                  role="tabpanel"
                  aria-labelledby="nav-vimeo-tab"
                >
                  <div className="vimeo_sec">
                    <div className="pt-3 pb-5">
                      {showVimeoSection && (
                        <form className="form_iv2 text-center m-auto">
                          <div className="social_logo mb-4 pb-2">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/vimeo_logo.png"
                              }
                              className="img-fluid"
                              alt="img"
                            />
                          </div>
                          <input
                            type="text"
                            className="form-control txt_f_1 mb-3"
                            placeholder="Enter Video Link Here"
                            ref={vimeoRef}
                          />
                          <button
                            className="btn w-100 vimeo_btn"
                            onClick={(event) => handleClick(event, "vimeo")}
                          >
                            Get Video
                          </button>
                        </form>
                      )}

                      {showVmVideoFiles && (
                        <div className="acceptFiles">
                          <div className="form-group row">
                            <label
                              htmlFor="inputCname"
                              className="col-sm-2 col-form-label"
                            >
                              Campaign Name
                            </label>
                            <div className="col-sm-10">
                              <Input
                                ref={campaignRef}
                                name="campaign_name"
                                type="text"
                                placeholder="Enter Campaign Name"
                                maxLength={31}
                                inputClass={`form-control ${
                                  campaign.campaign_name.length >= 31 &&
                                  "is-invalid max-length"
                                } ${
                                  !campaign.is_available &&
                                  campaign.is_available !== undefined &&
                                  "is-invalid invalid"
                                } ${campaign.is_available && "is-valid"}`}
                                onChange={campaignHandler}
                                onBlur={campaignHandlerBlur}
                                value={campaign.campaign_name}
                                autoFocus={true}
                              />

                              {!campaign.is_available &&
                                campaign.is_available !== undefined && (
                                  <div className={`invalid-feedback`}>
                                    Already Exist!
                                  </div>
                                )}
                              {campaign.campaign_name.length >= 31 && (
                                <div className={`invalid-feedback`}>
                                  Campaign Name should not be Exceeded 30 Char
                                </div>
                              )}
                              {campaign.is_available &&
                                campaign.campaign_name.length <= 30 && (
                                  <div className={`valid-feedback`}>
                                    {"Available"}
                                  </div>
                                )}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="staticEmail"
                              className="col-sm-2 col-form-label"
                            >
                              Selected File
                            </label>
                            <div className="col-sm-10">
                              <div className="small-8 pull-left image-gallery">
                                <div className="image pull-left import-video-form-preview">
                                  {/* <img src={process.env.PUBLIC_URL+"/assets/images/video-thumb.png"} alt="Video Thumbnail" className="gallery-view"/> */}
                                  <iframe
                                    src={vmvideoLink}
                                    title="Your Video"
                                  ></iframe>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Add Tags{" "}
                            </label>
                            <div className="col-sm-10">
                              <TagsInput
                                selectedTags={addTags}
                                setAddTags={setAddTags}
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputVtitle"
                              className="col-sm-2 col-form-label"
                            >
                              Description{" "}
                            </label>
                            <div className="col-sm-10">
                              <textarea
                                className="form-control height80"
                                placeholder="Enter a nice description..."
                                onChange={(event) =>
                                  setAddDesc(event.target.value)
                                }
                                value={addDesc}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="iv_footer">
                      <div className="btn_wrap_p text-end mt-2">
                        {showVmVideoFiles && (
                          <button
                            className="btn btn2 me-2"
                            onClick={(e) => handleChange(e, "changeVmVideo")}
                          >
                            Change Video
                          </button>
                        )}

                        {showVimeoSection && (
                          <button
                            className="btn btn2 me-2"
                            onClick={() => setShowImportvideo(false)}
                          >
                            Cancel
                          </button>
                        )}
                        <button
                          className="btn btn1"
                          disabled={
                            vmvideoLink.length === 0 ||
                            campaign.campaign_name.length === 0
                              ? true
                              : false
                          }
                          onClick={(e) => handleClick(e, "getVimeovideo")}
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportvideoModals;
